// extracted by mini-css-extract-plugin
export default {"container":"Textarea_container__ftg4X","label":"Textarea_label__KT8Oa","textarea":"Textarea_textarea__-YIIG","limit":"Textarea_limit__SGzML"};